function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.07 1.6l4.357 4.438A2 2 0 0128 7.44V29a2 2 0 01-2 2H6a2 2 0 01-2-2V3a2 2 0 012-2h15.643a2 2 0 011.428.6zM21.644 3L26 7.44V29H6V3h15.643z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 9A.75.75 0 019 8.25h8a.75.75 0 010 1.5H9A.75.75 0 018.25 9zM9 12.25a.75.75 0 000 1.5h14a.75.75 0 000-1.5H9zM8.25 17a.75.75 0 01.75-.75h14a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM9 20.25a.75.75 0 000 1.5h14a.75.75 0 000-1.5H9zM9 24.25a.75.75 0 000 1.5h14.07a.75.75 0 000-1.5H9z",
  fill: "currentColor"
})));